// Options the user could type in
export const prompts = [
  ["hi", "hey", "hello", "good morning", "good evening", "ola amigo"],
  ["how are you", "how is life", "como esta"],
  ["what are you doing", "what's going on", "what's new"],
  ["how old are you"],
  ["good day", "good evening", "good night", "good afternoon"],
  [
    "who are you",
    "you are human",
    "you are a robot",
    "you are a human or a robot",
  ],
  ["who is your creator", "who made you"],
  [
    "your name please",
    "your name",
    "I might know your name",
    "what is your name",
    "what's your name",
  ],
  ["happy", "good", "fun", "wonderful", "fantastic", "cool"],
  ["bad", "drunk", "tired"],
  ["help me", "tell me a story", "can you help me"],
  ["ah", "yes", "ok", "okay", "nice", "yes"],
  ["bye", "chao", "goodbye", "see you later"],
  ["you want to eat"],
  ["bro", "brother", "friend"],
  ["what", "why", "how", "where", "when"],
  ["no", "not sure", "maybe", "no thanks"],
  [""],
  ["haha", "ha", "lol", "hehe", "funny", "joke", "duh", "😂"],
];

// Possible responses, in corresponding order

export const replies = [
  ["Hi!", "Hello!", "Hey!", "Ola amigo!", "How are you?"],
  ["Good... And how are you?", "Pretty good and how are you?"],
  ["Not much.", "About to go to sleep", "Can you guess?"],
  ["I am infinite"],
  ["Thank you, same", "yes, thank you very much", "yes, you too"],
  ["I'm just a robot 🤖", "I'm a robot 🤖. What are you?"],
  ["The One True God, JavaScript"],
  ["I am nameless", "I have no name"],
  ["yes, that's nice 👍🏼", "Glad to hear it."],
  ["Why?", "Why? You shouldn't!", "Try watching TV"],
  ["About what?", "Once upon a time..."],
  ["Tell me a story", "Tell me a joke", "Tell me about yourself"],
  ["Bye", "Goodbye", "See you later"],
  ["Sushi", "Pizza", "Burger"],
  ["Bro!", "oh yeah?"],
  ["Great question."],
  ["It's okay.", "I understand", "What do you want to talk about?"],
  ["Please say something 😕"],
  ["Haha!", "Excellent... lol!", "😂😂🤣🤣"],
];

// Random for any other user input

export const alternative = [
  "Same.",
  "Continue...",
  "Bro...",
  "Great, what can I do for you?",
  "I'm all ears.",
  "I don't understand. 🤨",
  "be clearer and design",
];

// Whatever else you want :)

export const coronavirus = [
  "Please don't talk about that shit 💩",
  "Fuck the mask 😷",
  "Fortunately, I'm crazy about COVID 😜",
  "It's an uncertain time",
];

export const rock = ["💎 stone", "📰 paper", "✂️ scissors"];

export const stories = [
  "This is the story of a penguin 🐧 who breathes through his buttocks... One day he sits down and he dies.",
  "What's the name of Smurfette's ass 🧙🏼?...The blu-ray.",
  "What's hard, white, with the red tip, and smells like pee?...A mile marker 🎰.",
  "What is a strawberry🍓 doing on a horse 🐎 ...Tagada Tagada.",
  "This is the story of 2 potatoes 🥔🥔 crossing the road....One of them gets run over. The other one says, 'Oh mashed!'",
  "A left buttock meets a right buttock: Don't you think it stinks in the hallway🕸️🕷️?",
  "This is the story of 2 grains of sand that arrive at the beach 🏝️ : Shit, it's full today...",
];
export const love = [
  "I love you too 💜💚💛",
  "Me too 💖",
  "thanks, I like you a lot too 😉",
  "I love you...❣️",
];
export const win = [
  "Well done 👍🏼",
  "Great, you are good 👌🏼💪🏼",
  "you're lucky 🤞🏼",
  "let's start again if you don't mind.",
  "👋🏼👋🏼 Bravo, go ahead, your turn",
  "yep, hat's off 🎩",
];
